// extracted by mini-css-extract-plugin
module.exports = {"category":"faqCategoryContent_category__xbxwY","title":"faqCategoryContent_title__SGrnh"};